const UTM_DATA_KEY = "obj_data"
const UTM_TTL_MS = 7 * 24 * 60 * 60 * 1000

const isExpired = (savedAt) => {
  if (!savedAt) return false
  return Date.now() - savedAt > UTM_TTL_MS
}

export const migrateUtmFromSessionStorage = () => {
  if (typeof window === "undefined") return

  const legacy = sessionStorage.getItem(UTM_DATA_KEY)
  if (!legacy) return

  try {
    const parsed = JSON.parse(legacy)
    setUtmData(parsed)
    sessionStorage.removeItem(UTM_DATA_KEY)
  } catch {
    sessionStorage.removeItem(UTM_DATA_KEY)
  }
}

export const getUtmData = () => {
  if (typeof window === "undefined") return null

  try {
    const raw = localStorage.getItem(UTM_DATA_KEY)
    if (!raw) return null

    const parsed = JSON.parse(raw)

    if (parsed?.saved_at !== undefined) {
      if (isExpired(parsed.saved_at)) {
        localStorage.removeItem(UTM_DATA_KEY)
        return null
      }
      return parsed.data ?? null
    }

    setUtmData(parsed)
    return parsed
  } catch {
    localStorage.removeItem(UTM_DATA_KEY)
    return null
  }
}

export const setUtmData = (data) => {
  if (typeof window === "undefined") return

  localStorage.setItem(
    UTM_DATA_KEY,
    JSON.stringify({
      saved_at: Date.now(),
      data,
    })
  )
}
